export default "__VITE_ASSET__CzpQqbPI__"